var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"full-width",attrs:{"src":_vm.itemDetails.barcode}})])
}
var staticRenderFns = []

export { render, staticRenderFns }